import { render, staticRenderFns } from "./WorkWithUs.vue?vue&type=template&id=2d45a896&scoped=true"
import script from "./WorkWithUs.vue?vue&type=script&lang=ts"
export * from "./WorkWithUs.vue?vue&type=script&lang=ts"
import style0 from "./WorkWithUs.vue?vue&type=style&index=0&id=2d45a896&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d45a896",
  null
  
)

export default component.exports